/**
 * @generated SignedSource<<0eacd8a9c539248e6f9bbb7d5e55ee20>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SncOrderStatus = "CLOSED" | "FILLED" | "OPEN" | "PURCHASED" | "%future added value";
export type thankYouSncOrderQuery$variables = {
  clientReferenceId: string;
};
export type thankYouSncOrderQuery$data = {
  readonly sncOrder: {
    readonly amount: number;
    readonly createdAt: any;
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly id: string;
        readonly name: string;
        readonly postalCode: string;
        readonly street: string;
      };
      readonly sncProducts: {
        readonly nodes: ReadonlyArray<{
          readonly id: string;
          readonly stock: number;
          readonly " $fragmentSpreads": FragmentRefs<"SncProductCardFragment">;
        }>;
      };
    };
    readonly id: string;
    readonly lineItems: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly priceAmount: number;
        readonly sncProduct: {
          readonly id: string;
          readonly product: {
            readonly id: string;
            readonly name: string;
          };
        };
      }>;
    };
    readonly organization: {
      readonly id: string;
      readonly logo: {
        readonly id: string;
        readonly variant: string;
      } | null | undefined;
      readonly name: string;
      readonly supportEmail: string | null | undefined;
    };
    readonly status: SncOrderStatus;
  };
};
export type thankYouSncOrderQuery = {
  response: thankYouSncOrderQuery$data;
  variables: thankYouSncOrderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "clientReferenceId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "clientReferenceId",
        "variableName": "clientReferenceId"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "meta",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "active": true
    }
  },
  {
    "kind": "Literal",
    "name": "pagination",
    "value": {
      "page": 0,
      "pageSize": 4
    }
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stock",
  "storageKey": null
},
v10 = [
  (v2/*:: as any*/),
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "variant",
        "value": "PUBLIC"
      }
    ],
    "kind": "ScalarField",
    "name": "variant",
    "storageKey": "variant(variant:\"PUBLIC\")"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportEmail",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CloudflareImage",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": (v10/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceAmount",
  "storageKey": null
},
v13 = [
  (v2/*:: as any*/),
  (v6/*:: as any*/)
],
v14 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000000
      }
    }
  ],
  "concreteType": "SncLineItemPage",
  "kind": "LinkedField",
  "name": "lineItems",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SncLineItem",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        (v12/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SncProduct",
          "kind": "LinkedField",
          "name": "sncProduct",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": (v13/*:: as any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "lineItems(pagination:{\"page\":0,\"pageSize\":1000000})"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "thankYouSncOrderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "SncOrder",
          "kind": "LinkedField",
          "name": "sncOrder",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Hub",
              "kind": "LinkedField",
              "name": "hub",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                {
                  "kind": "RequiredField",
                  "field": (v7/*:: as any*/),
                  "action": "THROW"
                },
                {
                  "alias": null,
                  "args": (v8/*:: as any*/),
                  "concreteType": "SncProductPage",
                  "kind": "LinkedField",
                  "name": "sncProducts",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "SncProduct",
                      "kind": "LinkedField",
                      "name": "nodes",
                      "plural": true,
                      "selections": [
                        (v2/*:: as any*/),
                        (v9/*:: as any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "SncProductCardFragment"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "sncProducts(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":4})"
                }
              ],
              "storageKey": null
            },
            (v11/*:: as any*/),
            (v14/*:: as any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "thankYouSncOrderQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SncOrder",
        "kind": "LinkedField",
        "name": "sncOrder",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": (v8/*:: as any*/),
                "concreteType": "SncProductPage",
                "kind": "LinkedField",
                "name": "sncProducts",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SncProduct",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      (v9/*:: as any*/),
                      (v12/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "description",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": (v10/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Brand",
                            "kind": "LinkedField",
                            "name": "brand",
                            "plural": false,
                            "selections": (v13/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v6/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "i18N",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "sncProducts(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":4})"
              }
            ],
            "storageKey": null
          },
          (v11/*:: as any*/),
          (v14/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c2783f7b995a1f7e4343577dbeee3482",
    "id": null,
    "metadata": {},
    "name": "thankYouSncOrderQuery",
    "operationKind": "query",
    "text": "query thankYouSncOrderQuery(\n  $clientReferenceId: String!\n) {\n  sncOrder(by: {clientReferenceId: $clientReferenceId}) {\n    id\n    status\n    amount\n    createdAt\n    hub {\n      id\n      meta {\n        id\n        name\n        street\n        city\n        postalCode\n      }\n      sncProducts(filter: {active: true}, pagination: {page: 0, pageSize: 4}) {\n        nodes {\n          id\n          stock\n          ...SncProductCardFragment\n        }\n      }\n    }\n    organization {\n      id\n      name\n      supportEmail\n      logo {\n        id\n        variant(variant: PUBLIC)\n      }\n    }\n    lineItems(pagination: {page: 0, pageSize: 1000000}) {\n      nodes {\n        id\n        priceAmount\n        sncProduct {\n          id\n          product {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment SncProductCardFragment on SncProduct {\n  id\n  priceAmount\n  stock\n  active\n  product {\n    id\n    name\n    description\n    photo {\n      id\n      variant(variant: PUBLIC)\n    }\n    brand {\n      id\n      name\n    }\n    category {\n      id\n      name\n      i18N\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c33cf21f4c88b30259ab906d509fbbd6";

export default node;
